const NOTE_NAMES = { C: 0, D: 2, E: 4, F: 5, G: 7, A: 9, B: 11 };
const MAJOR = [0, 2, 4, 5, 7, 9, 11];
const MINOR = [0, 2, 3, 5, 7, 8, 10];

export function parseSessionKey(value) {
  const match = /^\s*([A-Ga-g])([#b]?)\s+(maj(?:or)?|min(?:or)?)\s*$/.exec(String(value || ''));
  if (!match) return null;
  let root = NOTE_NAMES[match[1].toUpperCase()];
  if (match[2] === '#') root += 1;
  if (match[2] === 'b') root -= 1;
  root = (root + 12) % 12;
  const mode = match[3].toLowerCase().startsWith('maj') ? 'major' : 'minor';
  return { root, mode, pitchClasses: (mode === 'major' ? MAJOR : MINOR).map((interval) => (root + interval) % 12) };
}

export function pitchInKey(pitch, parsedKey) {
  return !parsedKey || parsedKey.pitchClasses.includes(((Number(pitch) % 12) + 12) % 12);
}

export function foldPitchToKey(pitch, parsedKey) {
  const input = Math.max(0, Math.min(127, Math.round(Number(pitch))));
  if (!parsedKey || pitchInKey(input, parsedKey)) return input;
  for (let distance = 1; distance < 12; distance += 1) {
    const down = input - distance;
    const up = input + distance;
    if (down >= 0 && pitchInKey(down, parsedKey)) return down;
    if (up <= 127 && pitchInKey(up, parsedKey)) return up;
  }
  return input;
}

export const KEY_OPTIONS = [
  '', 'C maj', 'C min', 'C# maj', 'C# min', 'D maj', 'D min', 'Eb maj', 'Eb min',
  'E maj', 'E min', 'F maj', 'F min', 'F# maj', 'F# minor', 'G maj', 'G min',
  'Ab maj', 'Ab min', 'A maj', 'A min', 'Bb maj', 'Bb min', 'B maj', 'B min',
];
